import { lazy } from "react";
import LocalReportApp from "../reports/LocalReportApp";
import NewReportApp from "../reports/NewReportApp";
import LocalApp from "./LocalApp"
import ViewReport from "../reports/components/ViewReport";
import ViewReportImages from "../reports/components/ViewReportImages";
import ViewReportGeneralDrowsiness from "../reports/components/ViewReportGeneralDrowsiness";
import ViewReportRoomDrowsiness from "../reports/components/ViewReportRoomDrowsiness";
import ViewReportHoteliers from "../reports/components/ViewReportHoteliers";

const LocalConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: 'local',
			element: <LocalApp />,
		},
		{
			path: "local/:id",
			element: <LocalReportApp />,
		},
		// {
		// 	path: "local/:id/new",
		// 	element: <NewReportApp />,
		// },
		{
			path: "local/:id/view/:reportId",
			element: <ViewReport />
		},
		{
			path: "local/:id/viewImages/:reportId",
			element: <ViewReportImages />
		},
		{
			path: "local/:id/viewGeneralDrowsiness/:reportId",
			element: <ViewReportGeneralDrowsiness />
		},
		{
			path: "local/:id/viewRoomDrowsiness/:reportId",
			element: <ViewReportRoomDrowsiness />
		},
		{
			path: "local/:id/viewHoteliers/:reportId",
			element: <ViewReportHoteliers />
		},
	]
};

export default LocalConfig;
